import { fetchAndDeserializeVersionedTransaction } from "@bridgesplit/utils";

import {
    AbfTransactionHeaders,
    TXN_CREDITBOOK_MANAGE_RAYDIUM_LIQUIDITY,
    TXN_CREDITBOOK_TRANSFER_RAYDIUM_POSITION,
    TxnManageRaydiumLiquidityParams,
    TxnTransferRaydiumPositionParams
} from "../types";
import { createMarketsInstance } from "./auth";

export async function getRaydiumUpdateLiquidityTransaction(
    authentication: AbfTransactionHeaders,
    args: TxnManageRaydiumLiquidityParams
) {
    return [
        await fetchAndDeserializeVersionedTransaction(
            createMarketsInstance(authentication),
            TXN_CREDITBOOK_MANAGE_RAYDIUM_LIQUIDITY,
            args
        )
    ];
}

export async function getRaydiumTransferPositionTransaction(
    authentication: AbfTransactionHeaders,
    args: TxnTransferRaydiumPositionParams
) {
    return [
        await fetchAndDeserializeVersionedTransaction(
            createMarketsInstance(authentication),
            TXN_CREDITBOOK_TRANSFER_RAYDIUM_POSITION,
            args
        )
    ];
}
